import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from '@cmps/ng-select';
import { CmpsDialogModule, CmpsIconModule } from '@cmps/ng-uikit';

import { CmpsAuthModule } from '../auth/auth.module';
import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsLazyRouterModule } from '../route.module';

import { HierarchyProfileComponent } from './hierarchy.profile.component';
import { PasswordProfileComponent } from './password.profile.component';
import {
    ProfileChangePictureComponent,
    ProfilePictureBtn,
} from './profile-change-picture.component';
import { ProfileComponent } from './profile.component';
import { TranslationIdMap } from './profile.i18n';
import { ProfileRoutes } from './profile.route';
import { SecurityQuestionProfileComponent } from './security-question.profile.component';
import { SuperGroupProfileComponent } from './supergroup.profile.component';
import { SystemIdProfileComponent } from './system-id.profile.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SelectModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsCommonModule,
        CmpsLazyRouterModule.forChild(ProfileRoutes),
        CmpsAuthModule,
        CmpsIconModule,
        CmpsDialogModule,
    ],
    declarations: [
        ProfilePictureBtn,
        ProfileChangePictureComponent,
        PasswordProfileComponent,
        SecurityQuestionProfileComponent,
        HierarchyProfileComponent,
        SuperGroupProfileComponent,
        SystemIdProfileComponent,
        ProfileComponent,
    ],
    exports: [ProfilePictureBtn, ProfileChangePictureComponent],
})
export class CmpsProfileModule {}
